import { AnimatePresence, motion, useAnimationControls } from 'framer-motion'
import { useEffect, useState } from 'react'
import { useNavigation } from 'react-router'
import { useSpinDelay } from 'spin-delay'
import { cn } from '#app/utils/misc.tsx'

function EpicProgress() {
	const transition = useNavigation()
	const busy = transition.state !== 'idle'
	const delayedPending = useSpinDelay(busy, {
		delay: 200,
		minDuration: 600,
	})
	const controls = useAnimationControls()
	const [animationComplete, setAnimationComplete] = useState(true)

	useEffect(() => {
		if (delayedPending) {
			setAnimationComplete(false)

			if (transition.state === 'submitting') {
				void controls.start({
					width: '45%',
					transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] },
				})
			} else if (transition.state === 'loading') {
				void controls.start({
					width: '85%',
					transition: { duration: 1.2, ease: [0.25, 0.1, 0.25, 1] },
				})
			}
		} else {
			void controls
				.start({
					width: '100%',
					transition: { duration: 0.3, ease: [0.25, 0.1, 0.25, 1] },
				})
				.then(() => {
					void controls
						.start({
							opacity: 0,
							transition: { duration: 0.5, delay: 0.2 },
						})
						.then(() => {
							setAnimationComplete(true)
						})
				})
		}
	}, [delayedPending, transition.state, controls])

	return (
		<AnimatePresence>
			{(!animationComplete || delayedPending) && (
				<div
					role="progressbar"
					aria-hidden={delayedPending ? undefined : true}
					aria-valuetext={delayedPending ? 'Loading' : undefined}
					className="fixed inset-x-0 left-0 top-0 z-50 h-[0.15rem] overflow-hidden"
				>
					<motion.div
						initial={{ width: '5%', opacity: 0.7 }}
						animate={controls}
						className={cn(
							'h-full origin-left rounded-r-full bg-gradient-to-r from-foreground/60 via-foreground to-foreground/80',
						)}
						style={{
							boxShadow: '0 0 10px 0 rgba(var(--foreground-rgb), 0.25)',
						}}
					/>
				</div>
			)}
		</AnimatePresence>
	)
}

export { EpicProgress }
